import { ASSETS_PATH, COMMON_ICON } from 'constant/paymentConstants';

/**
 * Retrieves the icon URL for a specific credit card type.
 *
 * @param cardType - The type of the credit card (e.g., Visa, MasterCard, etc.).
 * @returns {string} - The URL to the icon representing the specified credit card type.
 *                     If the card type is not found, the default icon for Visa ('VI') is returned.
 */
export const getCreditCardTypeIcon = cardType =>
  cardType
    ? ASSETS_PATH.replace('%s', cardType)
    : ASSETS_PATH.replace('%s', COMMON_ICON);
